
import { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, useIntl, WrappedComponentProps } from 'react-intl';
import { Col, Row } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { FilterType, getDashboarReports, getTrendsReports } from '@store/slices';

import { DashboardReportHeader } from './dashboard-report-header';
import { DashboardReportTopDestinations } from './dashboard-report-top-destinations';
import { DashboardReportTopMembers } from './dashboard-report-top-members';
import { DashboardReportRoomsBooked } from './dashboard-report-rooms-booked';
import { DashboardReportBookingsTotalBar } from './dashboard-report-bookings-total';
import { DashboardReportBookingsTotalPie } from './dashboard-report-bookings-total-pie';
import { DashboardReportFilters } from './dashboard-report-filters';

import './style.scss';
import { DashboardReportCarsBooked } from './dashboard-report-cars-booked';

export const MONTHLY = 'MONTHLY';
export const DAILY = 'DAILY';

interface IMapDispatchToProps {
  getDashboarReports: () => void;
  getTrendsReports: () => void;
}

interface IProps extends IMapDispatchToProps, RouteComponentProps, WrappedComponentProps {
  isV2: boolean;
}

function DashboardReportComponent(props: IProps) {
  const [period, setPeriod] = useState(MONTHLY);
  const [activeTab, setActiveTab] = useState<string>('summary');
  const [filterValue, setFilterValue]= useState<string>(FilterType.ALL);

  const { getDashboarReports, getTrendsReports } = props;
  
  useEffect(() => {
    if (props.isV2) {
      getTrendsReports();
    }
    else {
      getDashboarReports();
    }
  }, []);
  
  const intl = useIntl();
  return (
    <div className="dasshboard-reports-wrapper">
      <Row className="gy-4">
        <Col xl={12}>
          <div className="dasshboard-reports-wrapper__title">
            {!props.isV2 ? <span className="title-description"><FontAwesomeIcon icon={faChartLine} /><h1><FormattedMessage id="trends" /></h1></span> : null}
            <DashboardReportFilters isV2={props.isV2} activeTab={activeTab} setActiveTab={setActiveTab} filterValue={filterValue} setFilterValue={setFilterValue}/>
          </div>
        </Col>

        {activeTab === 'summary' && (
          <>
            <Col xl={12}>
              <DashboardReportHeader/>
            </Col>

            <Col xs={12}>
              <div className="dasshboard-reports-wrapper__row">
                <div className="dasshboard-reports-wrapper__row-left">
                  <DashboardReportBookingsTotalBar period={period} onPeriodChange={setPeriod} intl={intl}/>
                </div>
              </div>
            </Col>

           {filterValue === FilterType.HOTELS && (
              <Col xs={12}>
                <DashboardReportRoomsBooked />
              </Col>
            )}
            {filterValue === FilterType.CARS && (
              <Col xs={12}>
                <DashboardReportCarsBooked />
              </Col>
            )}
            {filterValue === FilterType.ALL && (
              <Col xs={12}>
                <DashboardReportRoomsBooked />
                <div className='mt-4'><DashboardReportCarsBooked /></div>
              </Col>
            )}

            <Col xs={12} lg={6}>
              <div className="dasshboard-reports-wrapper__row">
                <div className="dasshboard-reports-wrapper__row-right">
                  <DashboardReportBookingsTotalPie period={period} />
                </div>
              </div>
            </Col>

          </>)}

        {activeTab === 'top_destinations' && (
          <Col xs={12}>
            <DashboardReportTopDestinations intl={intl}/>
          </Col>)}

        {activeTab === 'top_travelers' && (
          <Col xs={12}>
            <DashboardReportTopMembers intl={intl} filterValue={filterValue}/>
          </Col>)}
      </Row>
    </div >
  );
}

const mapDispatchToProps: IMapDispatchToProps = {
  getDashboarReports,
  getTrendsReports
};

const ComponentIntl = injectIntl(DashboardReportComponent);

export const DashboardReport = connect(null, mapDispatchToProps)(withRouter(ComponentIntl));
